
import React from 'react';
import QRCodeComponent from './QRCode';
import { useAuth } from '../contexts/AuthContext';

export default function MyCoupons() {
  const { user } = useAuth();
  const baseCouponUrl = 'https://brucaliffo.appsmith.com/app/my-first-application/page3-6991efb46502d159ccfd9472';
  const identifier = user?.id || user?.email || '';
  const couponUrl = identifier ? `${baseCouponUrl}?user=${encodeURIComponent(identifier)}` : baseCouponUrl;
  return (
    <div className="form-container">
      <h2>Benvenuto nella pagina Cupon</h2>
      <QRCodeComponent url={couponUrl} />
    </div>
  );
}